import { QueueCarriers } from '#components/QueueCarriers'
import { QueueStatus } from '#components/QueueStatus'

const TrackingQueueStatus = () => (
  <div className="space-y-6">
    <QueueStatus endpoint="trackings/queue-status" />
    <QueueCarriers endpoint="trackings/queue-breakdown" />
  </div>
)

export { TrackingQueueStatus }
